module.exports = __webpack_public_path__ + "assets/img/daolan.8ea0394b.png";